export default [
  {
    path: '/kompack-data-mitra-gudang',
    name: 'kompack-data-mitra-gudang',
    component: () => import('@/views/pages/kompack/mitragudang/List'),
    meta: {
      resource: 'Kompack',
      action: 'manage',
    },
  },
  {
    path: '/kompack-tambah-list-data-mitra-gudang',
    name: 'kompack-tambah-list-data-mitra-gudang',
    component: () => import('@/views/pages/kompack/mitragudang/tambahlistdatamitragudang'),
    meta: {
      navActiveLink: 'kompack-data-mitra-gudang',
      resource: 'Kompack',
      action: 'manage',
    },
  },
  {
    path: '/kompack-rincian-mitra-gudang/:id',
    name: 'kompack-rincian-mitra-gudang',
    component: () => import('@/views/pages/kompack/mitragudang/rincianmitragudang'),
    meta: {
      navActiveLink: 'kompack-data-mitra-gudang',
      resource: 'Kompack',
      action: 'manage',
    },
  },
  {
    path: '/kompack-rincian-mitra-gudang/:id/information',
    name: 'kompack-rincian-mitra-gudang-information',
    component: () => import('@/views/pages/kompack/mitragudang/rincianinfomitragudang'),
    meta: {
      navActiveLink: 'kompack-data-mitra-gudang',
      resource: 'Kompack',
      action: 'manage',
    },
  },
  {
    path: '/kompack-performa-mitra-gudang',
    name: 'kompack-performa-mitra-gudang',
    component: () => import('@/views/pages/kompack/mitragudang/performa-mitra/PerformaMitra.vue'),
    meta: {
      resource: 'Kompack',
      action: 'manage',
    },
  },
  {
    path: '/kompack-daftar-partner',
    name: 'kompack-daftar-partner',
    component: () => import('@/views/pages/kompack/partner/PartnerList.vue'),
    meta: {
      resource: 'Kompack',
      action: 'manage',
    },
  },
  {
    path: '/kompack-request-packing',
    name: 'kompack-request-packing',
    component: () => import('@/views/pages/kompack/dashboard/request-packing/RequestPacking.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack',
      action: 'manage',
    },
  },
  {
    path: '/kompack-pengajuan-barang-rusak',
    name: 'kompack-pengajuan-barang-rusak',
    component: () => import('@/views/pages/kompack/dashboard/pengajuan-barang-rusak/PengajuanBarangRusak.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack',
      action: 'manage',
    },
  },
  {
    path: '/kompack-request-penarikan-barang',
    name: 'kompack-request-penarikan-barang',
    component: () => import('@/views/pages/kompack/dashboard/request-penarikan-barang/RequestPenarikanBarang.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack',
      action: 'manage',
    },
  },
  {
    path: '/kompack-partner-low-moving-stock',
    name: 'kompack-partner-low-moving-stock',
    component: () => import('@/views/pages/kompack/dashboard/partner-low-moving-stock/PartnerLowMovingStock.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack',
      action: 'manage',
    },
  },
]
